<div class="modal fade" id="savedAccountModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="apiAccessTitle">Select Account/Card for payment</h5>
        <button id="closeSavedAccountModal" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container">
          <!-- <div *ngIf="accountPaymentSetting && accountPaymentSetting.paymentInstruments" class="row font13-400 pointer">
            <div *ngFor="let instrument of accountPaymentSetting.paymentInstruments; let i = index;"
              class="col-12 card mt-1 p-2" (click)="makePayment(instrument)">
              <div class="text-left font13-600">{{instrument.mode}}</div>
              <div class="custom-control custom-checkbox text-right">
                <input type="checkbox" class="custom-control-input pointer" id="paymentInstrument_{{i}}"
                  [checked]="instrument.isDefault" disabled>
                <label class="custom-control-label pointer" for="paymentInstrument_{{i}}"><small>Default</small></label>
              </div>
              <div *ngIf="instrument.mode == paymentTypes[0]"><span
                  class="font13-600">{{instrument.summary.accountType | customText}}</span>
                {{instrument.summary.accountNo}}</div>
              <div *ngIf="instrument.mode == paymentTypes[1]"><span
                  class="font13-600">{{instrument.summary.cardType}}</span> {{instrument.summary.cardNo}}</div>
            </div>
          </div> -->

          <ng-container *ngIf="accountPaymentSetting && accountPaymentSetting.paymentInstruments">
            <div *ngFor="let instrument of accountPaymentSetting.paymentInstruments; let i = index;"
              class="row border-bottom-grey mt-2 pb-2 font13-400"  [ngClass]="(selectedPaymentInstrumentIndex==i)?'input-bg-color p-2':''">
              <div class="col-8 pointer" (click)="makePayment(instrument); selectedPaymentInstrumentIndex = i">
                <div>
                  <span *ngIf="instrument.mode == paymentTypes[1] && getPaymentIcon(instrument.summary.cardType)"><img
                      class="img-fluid payment-icon" [src]="getPaymentIcon(instrument.summary.cardType)"
                      alt="{{instrument.summary.cardType}}" />&nbsp;</span>
                  <span>{{instrument.mode}}&nbsp;&nbsp;</span>
                  <span class="text-muted">ending in <span
                      *ngIf="instrument.mode == paymentTypes[0]">{{getLastFourDigit(instrument.summary.accountNo)}}</span><span
                      *ngIf="instrument.mode == paymentTypes[1]">{{getLastFourDigit(instrument.summary.cardNo)}}</span>&nbsp;&nbsp;</span>
                </div>
                <div class="mt-2 text-muted">
                  <span *ngIf="instrument.mode == paymentTypes[0]">{{instrument.summary.accountType | customText}}</span>
                  <span *ngIf="instrument.mode == paymentTypes[1]">Expiry: {{instrument.summary.expiry}}</span>
                </div>
                <div *ngIf="instrument.isDefault" class="mt-2 maroon"><i>(Preferred Payment Mode)</i></div>
                </div>
                <!-- Old code -->
                <!-- <div>
                  <span *ngIf="instrument.mode == paymentTypes[1] && getPaymentIcon(instrument.summary.cardType)"><img class="img-fluid payment-icon" [src]="getPaymentIcon(instrument.summary.cardType)" alt="{{instrument.summary.cardType}}"/>&nbsp;</span>
                  <span>{{instrument.mode}}&nbsp;&nbsp;</span>
                  <span class="text-muted">ending in <span
                      *ngIf="instrument.mode == paymentTypes[0]">{{getLastFourDigit(instrument.summary.accountNo)}}</span><span
                      *ngIf="instrument.mode == paymentTypes[1]">{{getLastFourDigit(instrument.summary.cardNo)}}</span>&nbsp;&nbsp;</span>
                  <span *ngIf="instrument.mode == paymentTypes[0]"
                    class="font13-600">{{instrument.summary.accountType | customText}}</span>
                </div>
                <div *ngIf="instrument.isDefault" class="mt-2 maroon"><i>(Preferred Payment Mode)</i></div>
              </div> -->
              <!-- <div class="col-4">
                <div *ngIf="instrument.mode == paymentTypes[1]" class="mt-2 text-muted text-right">Expiry: {{instrument.summary.expiry}}</div>
              </div> -->
            </div>
          </ng-container>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="goToPaymentScreen()">Use Another Payment Method</button>
      </div>
    </div>
  </div>
</div>


<button type="button" class="btn btn-primary" id="openSavedAccountModal" [hidden]="true" data-toggle="modal"
  data-target="#savedAccountModal" data-backdrop="static" data-keyboard="false">Hidden Btn</button>

<app-confirmation-modal modalId="confirmationModal" modalOpenButtonId="openConfirmationModal" modalCloseButtonId="closeConfirmationModal" 
  modalHeader="Auto Payment" content="Make Payment?" (saveEmitter)="confirmPayment()" 
  (cancelEmitter)="cancelPayment()" #confirmationModal></app-confirmation-modal>